import script from "./ageArea.vue?vue&type=script&setup=true&lang=js"
export * from "./ageArea.vue?vue&type=script&setup=true&lang=js"

import "./ageArea.vue?vue&type=style&index=0&id=519781e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-519781e2"]])

export default __exports__